import { Button } from '../../../../../../components/button/button';
import { Input } from '../../../../../../components/input/input';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { Select } from '../../../../../../components/select/select';
import { MultiSelect } from '../../../../../../features/multi-select/multi-select';
import { useRolesDictionaryCreateModal } from './use-roles-dictionary-create-modal';

export const RolesDictionaryCreateModal = (props: ModalProps) => {
  const {
    adminIdValues,
    handleSubmit,
    role,
    rolesIdValues,
    // scopeIdValues,
    setRole,
    admins,
    t,
    isSystem,
    getLocale,
    isLoading,
  } = useRolesDictionaryCreateModal(props);

  return (
    <Modal {...props} title={t(role?.id ? 'Редактирование роли' : 'Создание роли')}>
      <Input
        value={role?.name}
        onChange={(e) => setRole({ ...role, name: e.currentTarget.value })}
        placeholder={t('Название роли')}
        disabled={!!isSystem}
      />
      {/* <Select
        options={scopeIdValues}
        value={scopeIdValues.find((item) => item.id === role?.scope)}
        placeholder={t('Выберите уровень видимости')}
        onSelect={(e) => setRole({ ...role, scope: e.id as RoleScope })}
        disabled={!!isSystem}
      /> */}
      {!role?.id && (
        <Select
          options={rolesIdValues}
          value={rolesIdValues.find((item) => item.id === role?.based_on)}
          placeholder={t('Взять за основную роль')}
          onSelect={(e) => setRole({ ...role, based_on: e.id })}
          disabled={!!isSystem}
        />
      )}
      {role?.id && (
        <MultiSelect
          placeholder={t('Сотрудники')}
          options={adminIdValues}
          onSelect={(e) =>
            setRole({
              ...role,
              employees: admins?.filter((item) => e.some((emp) => emp.id === String(item.id))),
            })
          }
          value={role?.employees?.map((emp) => ({
            id: String(emp.id),
            value: `${getLocale(emp.name)} ${getLocale(emp.surname)}`,
          }))}
        />
      )}
      <Button size="lg" onClick={handleSubmit} disabled={isLoading}>
        {t('Подтвердить')}
      </Button>
    </Modal>
  );
};
